import { useState, useEffect } from 'react';
import { useBikletaPointsService } from '../../../services/bikletaPoints/bikletaPointsService';
import { useStore } from '../../../utils/useStore';
import { ServiceViewController } from './interfaces';

const useServicesViewController = (): ServiceViewController => {
  const bpService = useBikletaPointsService();
  const { activePoint, setActivePoint, updateBikletaPoint } = useStore();

  const [services, setServices] = useState<
    {
      _id: string;
      value: string;
      label: string;
      appIconUrl?: string;
      webIconUrl?: string;
    }[]
  >([]);
  const [isLoadingServices, setIsLoadingServices] = useState(true);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const saveServices = async (servicesIds: string[]) => {
    if (!activePoint?._id) return;

    try {
      setIsSubmitting(true);

      const res = await bpService.updateService(activePoint._id, servicesIds);

      setActivePoint(res.data);
      updateBikletaPoint(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setIsLoadingServices(true);
        const response = await bpService.getPointServices();
        const servicesData = response.docs.map(service => ({
          _id: service._id,
          value: service.value,
          label: service.label,
          appIconUrl: service.appIconUrl,
          webIconUrl: service.webIconUrl,
        }));
        setServices(servicesData);
      } catch (error) {
        console.error('Error fetching point services:', error);
        // Keep empty array on error
        setServices([]);
      } finally {
        setIsLoadingServices(false);
      }
    };

    fetchServices();
  }, []);

  const setServiceState = async (servicesIds: string[]) => {
    try {
      const res = await bpService.updateService(activePoint._id, servicesIds);

      console.log(res.data);
      setActivePoint(res.data);
      updateBikletaPoint(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    setServiceState,
    services,
    isLoadingServices,
    isSubmitting,
    saveServices,
  };
};

export default useServicesViewController;
